import { TextField, Typography, FormControl, InputLabel, Box } from "@mui/material";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";

export default function PersonalInfoSection({
    form,
    setForm,
    translate,
    fieldSx,
    selectStyle,
    errors = {},
}) {
    const getFieldSx = (hasError) => ({
        ...fieldSx,
        "& .MuiOutlinedInput-root": hasError ? {
            "& fieldset": { borderColor: "var(--color-green-strong)" },
            "&:hover fieldset": { borderColor: "var(--color-green-strong)" },
            "&.Mui-focused fieldset": { borderColor: "var(--color-green-strong)" },
        } : {},
    });

    const helperTextStyle = {
        mt: 0.5,
        fontSize: 12,
        color: "var(--color-green-strong)",
    };

    return (
        <>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
                {translate("personal_information")}
            </Typography>

            <TextField
                label={translate("first_name")}
                fullWidth
                required
                value={form.first_name || ""}
                onChange={(e) => setForm((prev) => ({ ...prev, first_name: e.target.value }))}
                sx={getFieldSx(!!errors.first_name)}
            />
            {errors.first_name && (
                <Typography sx={helperTextStyle}>
                    {translate(errors.first_name)}
                </Typography>
            )}

            <TextField
                label={translate("last_name")}
                fullWidth
                required
                value={form.last_name || ""}
                onChange={(e) => setForm((prev) => ({ ...prev, last_name: e.target.value }))}
                sx={getFieldSx(!!errors.last_name)}
            />
            {errors.last_name && (
                <Typography sx={helperTextStyle}>
                    {translate(errors.last_name)}
                </Typography>
            )}

            <TextField
                label={translate("email")}
                type="email"
                fullWidth
                required
                value={form.email || ""}
                onChange={(e) => setForm((prev) => ({ ...prev, email: e.target.value }))}
                sx={getFieldSx(!!errors.email)}
            />
            {errors.email && (
                <Typography sx={helperTextStyle}>
                    {translate(errors.email)}
                </Typography>
            )}

            <TextField
                label={translate("password")}
                type="password"
                fullWidth
                required
                value={form.password || ""}
                onChange={(e) => setForm((prev) => ({ ...prev, password: e.target.value }))}
                sx={getFieldSx(!!errors.password)}
            />
            {errors.password && (
                <Typography sx={helperTextStyle}>
                    {translate(errors.password)}
                </Typography>
            )}

            <FormControl fullWidth required sx={fieldSx}>
                <InputLabel shrink>
                    {translate("country")}
                </InputLabel>

                <Box sx={errors.country_code ? {
                    border: "1px solid var(--color-green-strong)",
                    borderRadius: 1,
                } : {}}>
                    <CountryDropdown
                        value={form.country_code || ""}
                        valueType="short"
                        onChange={(country_code) =>
                            setForm((prev) => ({
                                ...prev,
                                country_code,
                                region: "",
                            }))
                        }
                        style={selectStyle}
                    />
                </Box>

                {errors.country_code && (
                    <Typography sx={helperTextStyle}>
                        {translate(errors.country_code)}
                    </Typography>
                )}
            </FormControl>

            <FormControl fullWidth required sx={fieldSx}>
                <InputLabel shrink>
                    {translate("region")}
                </InputLabel>

                <RegionDropdown
                    country={form.country_code || ""}
                    countryValueType="short"
                    value={form.region || ""}
                    onChange={(region) =>
                        setForm((prev) => ({
                            ...prev,
                            region,
                        }))
                    }
                    style={selectStyle}
                />

                {errors.region && (
                    <Typography sx={helperTextStyle}>
                        {translate(errors.region)}
                    </Typography>
                )}
            </FormControl>
        </>
    );
}